export default {
    title: 'Xcontact agente',
    badge: 'Distintivo',
    close: 'Fechar',
    pesquisarAtendimentos: 'Pesquisar atendimentos',
    resultadoPesquisa: 'Resultado da pesquisa',
    isRequired: 'É obrigatório',
    atendimentosDoCliente: 'Atendimentos do cliente',
    atendimentosAtivos: 'Atendimentos ativos',
    ultimosAtendimentos: 'Últimos atendimentos',
    indisponivel: 'Indisponível',
    fraseEncerramento: 'Deseja encerrar este atendimento?',
    fraseDeleteMsg: `Deseja apagar esta mensagem?`,
    legenda: `Legenda`,
    mensagemApagada: `Mensagem apagada`,
    pesquisarContatos: 'Pesquisa contatos',
    atendimentos: 'Atendimentos',
    ligacoes: 'Ligações',
    historico: 'Historico',
    contatos: 'Contatos',
    minhasFilas: 'Minhas filas',
    fraseInicial: 'A solução completa para gestão de fluxos de atendimento multi canais!',
    classificacao: 'Classificação',
    classificar: 'Classificar',
    cancelar: 'Cancelar',
    subClassificacao: 'Sub Classificação',
    observacao: 'Observação',
    sim: 'Sim',
    nao: 'Não',
    novaLigacao: 'Nova ligação',
    discar: 'Discar',
    ok: 'Ok',
    anexar: `Anexar`,
    digiteAqui: `Digite aqui...`,
    fraseNenhumaFilaVoz: 'Você não está registrado em nenhuma fila de Voz',
    fraseNenhumaFilaEmail: 'Você não está registrado em nenhuma fila de Email',
    fraseNenhumaFilaWhatsApp: 'Você não está registrado em nenhuma fila de WhatsApp',
    transferencia: 'Transferencia',
    transferir: 'Transferir',
    novoEmail: 'Novo Email',
    novoWhatsApp: 'Novo WhatsApp',
    continuar: 'Continuar',
    encerrarAtendimento: `Encerrar atendimento`,
    classificarAtendimento: `Classificar atendimento`,
    transferirAtendimento: `Transferir atendimento`,
    adicionarArquivos: `Adicionar arquivos`,
    desligar: 'Desligar',
    filaUnica: `Fila unica`,
    pausar: 'Pausar',
    removerPausa: 'Remover pausa',
    desativar: 'Desativar',
    ativar: 'Ativar',
    ligacoesAtivas: 'Ligações ativas',
    fraseSelecioneLigacao: 'Selecione uma ligação ou informe o destino',
    informeUmNumero: 'Informe um número',
    tipo: 'Tipo',
    configuracao: 'Configuração',
    enderecoXcontact: 'Endereço do Xcontact',
    salvar: 'Salvar',
    senha: 'Senha',
    entrar: 'Entrar',
    usuario: 'Usuario',
    idioma: 'Idioma',
    login: {
        title: 'Login',
        name: 'Nome',
        password: 'Senha',
        btLogin: 'Entrar',
        loginFail: 'Usuário ou senha inválidos',
    },
    dataIterator: {
        noResultsText: 'Nenhum dado encontrado',
        loadingText: 'Carregando itens...',
    },
    dataTable: {
        itemsPerPageText: 'Linhas por página:',
        ariaLabel: {
            sortDescending: ': Ordenado decrescente. Ative para remover a ordenação.',
            sortAscending: ': Ordenado crescente. Ative para ordenar decrescente.',
            sortNone: ': Não ordenado. Ative para ordenar crescente.',
        },
        sortBy: 'Ordenar por',
    },
    dataFooter: {
        itemsPerPageText: 'Itens por página:',
        itemsPerPageAll: 'Todos',
        nextPage: 'Próxima página',
        prevPage: 'Página anterior',
        firstPage: 'Primeira página',
        lastPage: 'Última página',
        pageText: '{0}-{1} de {2}',
    },
    datePicker: {
        itemsSelected: '{0} selecionado(s)',
    },
    noDataText: 'Não há dados disponíveis',
    carousel: {
        prev: 'Visão anterior',
        next: 'Próxima visão',
        ariaLabel: {
            delimiter: 'Slide {0} de {1} do carrossel',
        },
    },
    calendar: {
        moreEvents: 'Mais {0}',
    },
    fileInput: {
        counter: '{0} arquivo(s)',
        counterSize: '{0} arquivo(s) ({1} no total)',
    },
    timePicker: {
        am: 'AM',
        pm: 'PM',
    },
    queue: "Fila",
    queues: "Filas",
    agentes: "Agentes",
    DispositivoDeEntrada: "Dispositivo de entrada",
    DispositivoDeSaida: "Dispositivo de saida",
    DispositivoDeAlarme: "Dispositivo de toque",
    dadosDeIntegracao: "Dados de integração",
    nome: "nome",
    assunto: "assunto ",
    instancia: "instância",
    numero: "número",
    ajusteDeAudio: "Ajustes de Audio",
    agente: "agente",
    pesquiseAqui: "pesquise aqui",
    reproduzirAudioNasNotificaçõesDeMensagens: "reproduzir audio nas notificações de mensagens?",
    emAtendimento: "Em atendimento",
    finalizado: "Finalizado",
    disponivel: 'Disponivel',
    responder: 'responder',
    apagarMensagem: 'apagar mensagem',
    responderATodos: 'Responder a todos',
    encaminhar: 'Encaminhar',
    contato: 'contato',
    data: 'data',
    sentido: 'sentido',
    visualizar: 'visualizar',
    ligar: 'ligar',
    entrantes: 'Entrantes',
    saintes: 'Saintes',
    atendidas: 'Atendidas',
    naoAtendidas: 'Nao atendidas',
    sainte: 'sainte',
    entrante: 'entrante',
    habilitarNotificacaoes: 'habilitar  notificações?',
    dadosIndisponiveis: 'Dados indisponiveis',
    obrigaClassificarLigacao: 'Obrigar a classificação de  ligações',
    autoAtendimento: 'Auto atendimento',
    selecioneohorario: 'Selecione o horario',
    descricao: 'descrição',
    addUserConference: 'Adicionar participantes',
    Alerta: 'Alerta!',
    ultimoAgente: 'ultimo agente',
    Encerrado: 'Encerrado',
    Entrou: 'Em Atendimento',
    PreAtendimento: 'Pre Atendimento',
    ConexaoPerdida: 'Conexão perdida',
    DesconectadoDoServidor: "Desconectado",
    ConexaoEstabelecida: "Conexão estabelecida",
    ConectadoAoServidor: "Conectado ao servidor!",
    FilaDeEspera: "Fila de espera",
    editarContato: "Editar contato",
    Agendamento: "Agendamento",
    Naofoipossivelcompletaraligacao: 'Não foi possível completar a ligação',
    NaofoipossivelcompletaraligacaoOcupado: 'Destino ocupado',
    fraseAoFechar1: 'Certifique-se de que não há atendimentos pendentes.',
    fraseAoFechar2: 'Ao fechar o sistema o agente será removido de todas as filas!',
    fraseCampoObrigatorio: 'Campo obrigatorio!',
    transferir: "Transferir",
    configuracoesDeVoz: 'Configuração de audio',
    urlIntegracao: 'Url de integração',
    frasePerdaConexao: 'Conexão perdida com o servidor',
    enviarTemplate: 'Enviar template',
    salvarCredenciais: 'Salvar credenciais'










}
